import React from 'react';
import PropTypes from 'prop-types';
import { playerWrapper } from 'cccisd-survey-common';

import Retrospective from '../../../../../components/Retrospective';

class Player extends React.Component {
    static propTypes = {
        field: PropTypes.object,
        goToNextPage: PropTypes.func,
        saveStateAndMetrics: PropTypes.func,
        isPreview: PropTypes.bool,
    };

    render() {
        const { field, isPreview, saveStateAndMetrics } = this.props;

        if (isPreview) {
            return (
                <div>
                    1 Day Checklist <h5>Please add a page break after me.</h5>
                </div>
            );
        }

        return <Retrospective days={1} saveStateAndMetrics={saveStateAndMetrics} field={field} />;
    }
}

export default playerWrapper()(Player);
